import { bbtNative } from '@bbtfe/webview-bridge';

/** ready缓存 */
export let BBT_WEBVIEW_H5_READY = false;

export default () => {
  return new Promise(resolve => {
    bbtNative?.ready(() => {
      BBT_WEBVIEW_H5_READY = true;
      resolve(true);
    });
  });
};
